<template>
  <div>
    <!-- <HomeHeader @selected_tab="getMatches" /> -->
    <v-row no-gutters>
      <v-col cols="12" class="py-3">
        <!-- <Navigation v-if="url &&  ((maintenance_type != 'betgame' && maintenance_type != 'all') ||
          allowed_users.includes($auth.user && $auth.user.id + ''))" /> -->
        <!-- <Navigation v-if="((maintenance_type != 'all') ||
          allowed_users.includes($auth.user && $auth.user.id + ''))" /> -->
        <v-row class="pt-3">
          <v-col
            cols="12"
            v-if="
              loading &&
              ((maintenance_type != 'betgame' && maintenance_type != 'all') ||
                allowed_users.includes($auth.user && $auth.user.id + ''))
            "
          >
            <SkeletonLoader />
          </v-col>
        </v-row>
        <div
          id="bettech"
          v-if="
            url &&
            ((maintenance_type != 'betgame' && maintenance_type != 'all') ||
              allowed_users.includes($auth.user && $auth.user.id + ''))
          "
        >
          <MatchesData :selected_tab="selected_tab" :urlLink="this.url" />
        </div>
        <div
          v-if="
            !allowed_users.includes($auth.user && $auth.user.id + '') &&
            (maintenance_type == 'betgame' || maintenance_type == 'all')
          "
        >
          <Maintenance></Maintenance>
        </div>
      </v-col>
    </v-row>

    <!-- <v-row class="px-0">
      <v-col cols="12" lg="12" class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <v-row no-gutters>
            <v-col cols="12" class="pt-0">
              <Navigation />
              <div id="bettech" v-if="url">
                <MatchesData :selected_tab="selected_tab" :urlLink="this.url" />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-row> -->

    <!-- <v-row class="px-0">
      <v-col cols="12" lg="12" class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <v-row no-gutters>
            <v-col cols="12" class="pt-0">
              <Navigation />
              <div id="bettech" v-if="url">
                <MatchesData :selected_tab="selected_tab" :urlLink="this.url" />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { useScriptTag } from "@vueuse/core";
import { mdiReceiptTextOutline } from "@mdi/js";
import HomeHeader from "../components/HomeHeader.vue";
import MatchesData from "../components/tables/MatchesData.vue";
import OutrightData from "../components/tables/OutrightData.vue";
import MatchResultData from "../components/tables/MatchResultData.vue";
import OutrightResultData from "../components/tables/OutrightResultData.vue";
import Bets from "../components/bets/Bets.vue";
import BetsHistory from "../components/bets/BetsHistory.vue";
import Navigation from "../components/Navigations.vue";
import Maintenance from "../components/Maintenance.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import SkeletonLoader from "../../src/views/SkeletonHome.vue";
export default {
  components: {
    HomeHeader,
    MatchesData,
    OutrightData,
    MatchResultData,
    OutrightResultData,
    Bets,
    BetsHistory,
    Navigation,
    SkeletonLoader,
    Maintenance,
  },
  data() {
    return {
      tab: null,
      status_tab: null,
      side_tab: null,
      selected_tab: "",
      match_data: "",
      status: "active",
      mobile_match: "MATCHES",
      mobile_status: "ACTIVE",
      bet_slip_sheet: false,
      bet_history_sheet: false,
      receiptIcon: mdiReceiptTextOutline,
      url: "",
      user: null,
      tokenData: null,
      loading: true,
    };
  },
  computed: {
    // ...mapState("slotegator",["loading"])
    ...mapState("user", ["maintenance_type", "allowed_users"]),
  },
  methods: {
    ...mapActions("slotegator", ["init", "sportsbooks"]),
    ...mapMutations("slotegator", ["SET_SESSION_REFRESH"]),
    ...mapState("slotegator", ["session_refresh"]),
    getMatches(text) {
      this.selected_tab = text;
    },
    active() {
      this.status = "active";
    },
    results() {
      this.status = "results";
    },
    clickBetSlip: function () {
      this.bet_history_sheet = false;
      this.bet_slip_sheet = !this.bet_slip_sheet;
    },
    clickBetHistory: function () {
      this.bet_slip_sheet = false;
      this.bet_history_sheet = !this.bet_history_sheet;
    },
    sportsbookInit: async function () {
      const sportsbooks = await this.sportsbooks();
      const urlLink = await this.init({
        currency: process.env.VUE_APP_API_SPORTSBOOK_CURRENCY,
        sportsbook_uuid: sportsbooks.data.uuid,
        email: !!this.user ? this.user.email : "",
        player_id: !!this.user ? this.user.id : "",
        player_name: !!this.user ? this.user.name : "",
        session_id: "",
      });
      this.SET_SESSION_REFRESH(this.url);
      // const script = document.createElement("script");
      // script.src = this.url.src;
      // document.getElementsByTagName("src").appendChild(script);
      console.log("urlLinkz", urlLink.data);

      const { load } = useScriptTag(`${urlLink.data.src}`, async (el) => {}, {
        defer: true,
      });
      await load();
      this.url = urlLink.data;
    },
  },
  async mounted() {
    // const that = this;

    let skeletonTime = setInterval(() => {
      let elem = document.getElementById("bt-inner-page");
      if (elem) {
        this.loading = false;
        clearInterval(skeletonTime);
      }
    }, 100);
    await this.sportsbookInit();
  },
  async created() {
    this.user = this.$auth.user;
    this.tokenData = this.$cookies.get("_token");
    // console.log("hey", this.$cookies.get("_token"));
  },
};
</script>
